<template>
  <ul class="space-y-3.5">
    <li v-for="link in links" :key="link.text">
      <NuxtLink
        :to="link.link"
        :target="link.target"
        class="text-txsecondary font-normal text-sm inline-flex items-center gap-2 justify-center hover:underline whitespace-nowrap"
      >
        {{ link.text }}
      </NuxtLink>
    </li>
  </ul>
</template>

<script setup>
  const links = [
    {
      text: "Политика конфиденциальности",
      link: "/pdf/politic.pdf",
      target: "_blank",
    },
    {
      text: "Юридические документы",
      link: "/documents",
      target: "_self",
    },
  ];
</script>
